import { FormDivider } from '../formComponents';
import clsx from 'clsx';
import { FLEXI_QUOTE_FORM_CONTENT_QUERYResult } from 'sanity.types';

interface FlexiLeaseFormInfoLegendProps {
    flexiQuoteFormData: FLEXI_QUOTE_FORM_CONTENT_QUERYResult;
}

const FlexiLeaseFormInfoLegend = ({
    flexiQuoteFormData,
}: FlexiLeaseFormInfoLegendProps) => {
    const messages = flexiQuoteFormData?.[0]?.messages ?? [];

    if (messages.length === 0) return null;

    return (
        <>
            {messages.map((item, idx) => {
                if (!item) return null;

                const containerClasses = clsx(
                    'pt-0',
                    'p-2',
                    'text-sm',
                    item.textColor === 'red'
                        ? 'text-red-600'
                        : 'text-black-600',
                    'font-bold',
                    'text-center',
                    'text-balance',
                    'mb-4'
                );

                return (
                    <div key={item._key || idx}>
                        {item.content && (
                            <p className={containerClasses}>{item.content}</p>
                        )}
                        <FormDivider />
                    </div>
                );
            })}
        </>
    );
};

export default FlexiLeaseFormInfoLegend;
